import styles from './selected-pharmacy.module.css';
import { Button } from '@/components/button';
import { Section } from '@/components/containers/section';
import { useEncounter } from '@/contexts/encounter-context';
import { SectionHeader } from '@/components/section-header';
import { Navigate } from '@/util/react-router-dom';
import { PharmacyListCard } from './pharmacy-list-card';
import { VisitFormButtonRow } from '@/components/containers/visit-form-button-row';
import { useGetPharmacyById } from '@/api/get-pharmacy-by-id';
import { Loader } from '@/components/loaders/loader';
import { GetPharmacyInfoErrorType } from '@/api/api.schemas';
import { PharmacySelectionDescription } from './pharmacy-selection-description';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.pharmacySelection.selectedPharmacy';

interface SelectedPharmacyProps {
  pharmacyId: number;
  onEdit: () => void;
}

export function SelectedPharmacy({ pharmacyId, onEdit }: SelectedPharmacyProps) {
  const { t } = useTranslation();
  const { encounter } = useEncounter();

  const { data: pharmacyData, isFetching, error } = useGetPharmacyById(pharmacyId);

  if (error) {
    if (error.type === GetPharmacyInfoErrorType.NotFound) {
      return <Navigate to="/not-found" />;
    }

    return <Navigate to="/system-error" />;
  }

  return (
    <>
      <Section className={styles.form}>
        <PharmacySelectionDescription />
        <SectionHeader
          title={t(`${translationBase}.title`)}
          className={styles.sectionHeader}
          editButton={
            <Button variant="link" leftIcon="edit" onClick={onEdit}>
              {t(`${translationBase}.editButton`)}
            </Button>
          }
        />

        {isFetching || !pharmacyData?.pharmacy ? (
          <Loader type="small" />
        ) : (
          <PharmacyListCard pharmacy={pharmacyData.pharmacy} withoutSelectButton />
        )}
      </Section>

      <VisitFormButtonRow
        rightIcon="arrow_forward"
        buttonTextKey={'common.next'}
        nextStep={t(`${translationBase}.nextStep`)}
        as="a"
        to={`/visit/${encounter.id}/health-and-lifestyle`}
      />
    </>
  );
}
